<template>
  <div
    v-if="properties.length"
    class="content-block"
  >
    <template v-if="blocksVisibility['discover-you-new-home']">
      <h2 class="text-center mb-6 pb-6">
        Discover your new home
      </h2>
      <PortfolioSelect
        v-if="blocksVisibility['discover-you-new-home']"
        v-model="selectedPortfolioId"
        :portfolios="portfolios"
      />
    </template>

    <div
      v-if="propertiesGroup && blocksVisibility['featured-locations']"
      class="properties-group"
    >
      <div class="properties-group__header">
        {{ propertiesGroup.name }} Locations
      </div>
      <div class="properties-group__list">
        <v-row wrap>
          <v-col
            v-for="property in currentGroupItems"
            :key="property.id"
            cols="12"
            :sm="currentGroupItems.length < 3 ? 6 : 4"
          >
            <property-card :property="property" />
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-facing-decorator'
import { PortfolioItem } from '../../middleware/PortfolioItem'
import { Swiper, SwiperSlide } from 'swiper/vue'

import PropertyCard from './PropertyCard.vue'
import { SwiperOptions } from 'swiper/types/swiper-options'
import PortfolioSelect from './PortfolioSelect.vue'

const namespace: string = 'property'

@Component({
  components: {
    PortfolioSelect,
    Swiper,
    SwiperSlide,
    PropertyCard,
  },
})
export default class PropertiesPortfolio extends Vue {
  @Prop({ required: true, type: Object }) blocksVisibility: any

  get properties () {
    return this.$store.getters[`${namespace}/properties`]
  }

  get portfolios () {
    return this.$store.getters[`${namespace}/portfolios`]
  }

  get propertiesLoaded () {
    return this.$store.getters[`${namespace}/propertiesLoaded`]
  }

  get portfoliosLoaded () {
    return this.$store.getters[`${namespace}/portfoliosLoaded`]
  }

  preparedPortfolios: PortfolioItem[] = []

  selectedPortfolioId: number = null

  swiperOptions: SwiperOptions = {
    loop: true,
    autoplay: {
      delay: 5000,
    },
    spaceBetween: 30,
    watchOverflow: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2,
      },
      640: {
        slidesPerView: 3,
      },
      980: {
        slidesPerView: 4,
      },
    },
  }

  @Watch('propertiesLoaded')
  onPropertiesLoad () {
    this.preparePortfolios()
  }

  @Watch('portfoliosLoaded')
  onPortfoliosLoad () {
    this.preparePortfolios()
  }

  get propertiesGroup (): PortfolioItem | null {
    return this.preparedPortfolios.find(portfolio => portfolio.id === this.selectedPortfolioId) || null
  }

  get currentGroupItems () {
    if (!this.propertiesGroup) return false
    return this.propertiesGroup.properties.map(i => this.properties.find(({ id }) => id === i))
  }

  preparePortfolios () {
    if (!this.propertiesLoaded || !this.portfoliosLoaded) return
    this.preparedPortfolios = this.portfolios.map((portolioItem: PortfolioItem) => {
      return {
        ...portolioItem,
        properties: portolioItem.properties.filter(propertyId => {
          const property = this.properties.find(({ id }) => id === propertyId)
          // TODO For some reason backend sometimes returns nonexisting property ids.
          if (!property) {
            return false
          }
          if (property.status === 'DISABLED') {
            return false
          }
          return true
        }),
      }
    })

    this.selectedPortfolioId = this.preparedPortfolios[0] ? +this.preparedPortfolios[0].id : null
  }

  mounted () {
    if (!this.portfoliosLoaded) {
      this.$store.dispatch('property/loadPortfolios')
    }
    if (!this.propertiesLoaded) {
      this.$store.dispatch('property/loadProperties')
    }
    this.preparePortfolios()
  }
}
</script>

<style lang="scss">
  @import "@/assets/styles/variables.scss";

  .properties-group {
    &__header {
      font-family: $headers-font;
      font-style: normal;
      font-weight: 600;
      font-size: 1rem;
      text-transform: uppercase;
      color: var(--v-textSecondary-base);
      text-align: center;
      margin: 3.15rem 0;
    }
  }
</style>
